import {post} from '../utils'

export default host => (shortLink, receiver) =>
  post(`${host}/share_links/${shortLink}`,
    JSON.stringify({
      receiver: receiver,
      _method: "PUT"
    }))
    .then(response => response.json())